const ValuePreviewInline = ({className, label, value}) => {
    const classResult = className
        ? "preview-item d-inline-block ms-3 mb-3 " + className
        : "preview-item d-inline-block ms-3 mb-3"

    return (
        <div className={classResult}>
            <label className="text-muted">{label}</label>
            <div className="preview-input m-0 text-center">
                {value}
            </div>
        </div>
    )
}
export default ValuePreviewInline